/**
 * TopographicBackdrop
 * Decorative SVG backdrop for the marketing hero — a Landio-inspired
 * topographic mesh of subtly waved horizontal lines, masked so the pattern
 * intensifies toward the bottom and fades toward the top. Drifts horizontally
 * via a `drift` keyframe (defined in tailwind.config.ts).
 *
 * Pure CSS / SVG, no runtime deps. Position with absolute/-z-10 inside a
 * relative parent. Pointer-events disabled — purely decorative.
 */
export function TopographicBackdrop() {
  return (
    <div
      className="absolute inset-0 -z-10 pointer-events-none overflow-hidden"
      aria-hidden
    >
      <svg
        className="absolute inset-x-[-10%] top-0 h-full w-[120%] animate-drift"
        viewBox="0 0 1440 720"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* One wave row, tiled vertically to form the topographic mesh. */}
          <pattern
            id="topo-wave"
            width="200"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M0 20 Q 25 6, 50 20 T 100 20 T 150 20 T 200 20"
              fill="none"
              stroke="#7C3AED"
              strokeWidth="1"
              strokeOpacity="0.5"
            />
          </pattern>

          {/* Mask: stronger near the bottom, fades upward. */}
          <radialGradient id="topo-mask" cx="50%" cy="100%" r="100%">
            <stop offset="0%" stopColor="white" stopOpacity="0.9" />
            <stop offset="55%" stopColor="white" stopOpacity="0.35" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </radialGradient>

          <mask id="topo-mask-apply">
            <rect width="100%" height="100%" fill="url(#topo-mask)" />
          </mask>
        </defs>

        <rect
          width="100%"
          height="100%"
          fill="url(#topo-wave)"
          mask="url(#topo-mask-apply)"
          opacity="0.18"
        />
      </svg>
    </div>
  );
}
